$(document).ready(function () {
    //According page story
    $(".according-section .description-item .description-heading-item").on(
        "click",
        function (e) {
            e.preventDefault();
            var $this = $(this);

            if (!$this.hasClass("accordion-active")) {
                $(".description-content").slideUp(400);
                $(".description-heading-item").removeClass("accordion-active");
                $(".description-heading-icon").removeClass("accordion__rotate");
            }

            $this.toggleClass("accordion-active");
            $this.next().slideToggle();
            $(".description-heading-icon", this).toggleClass(
                "accordion__rotate"
            );
        }
    );
});
